import React, { useRef, useEffect } from 'react'

interface Props {
  className?: string
  inputClassName?: string
  style?: React.CSSProperties
  disabled?: boolean
  checked?: boolean
  onChange?: (() => void) | null
  labelOn?: string
  labelOff?: string
  widthOn?: number
  widthOff?: number
}

export const Toggle: React.FC<Props> = ({
  className = '',
  inputClassName = '',
  disabled = false,
  checked = false,
  onChange = null,
  labelOn = 'On',
  labelOff = 'Off',
  widthOn = null,
  widthOff = null,
}) => {
  const elementOffRef = useRef()
  const elementOnRef = useRef()
  const elementBackRef = useRef()

  const updateBackPosition = (elementBack: HTMLDivElement) => {
    const elementOffWidth =
      widthOff !== null ? `${widthOff}px` : window.getComputedStyle(elementOffRef.current).width

    if (checked) {
      // elementBack should go on the right
      const elementOnWidth =
        widthOn !== null ? `${widthOn}px` : window.getComputedStyle(elementOnRef.current).width
      elementBack.style.width = elementOnWidth
      elementBack.style.left = elementOffWidth
    } else {
      // elementBack should go on the left
      elementBack.style.width = elementOffWidth
      elementBack.style.left = '0'
    }
  }

  useEffect(() => {
    if (widthOn && widthOff) {
      updateBackPosition(elementBackRef.current)
    } else {
      setTimeout(() => updateBackPosition(elementBackRef.current), 1)
    }
  }, [checked])

  return (
    <div className="flex">
      <div
        className={`
        relative z-0 bg-gray100 flex items-center br-pill
        hover-bg-gray20
        ${disabled ? 'o-40 pointer-event-none' : ''}
        ${className}
      `}
      >
        <input
          className={`
            absolute z-2 top-0 left-0 o-0 bg-tomato w-100 h-100 br-pill
            ${disabled ? 'pointer-event-none' : 'pointer'}
            ${inputClassName}
          `}
          type="checkbox"
          checked={checked}
          onChange={disabled ? null : onChange}
        />
        <div
          ref={elementOffRef}
          className={`relative f6 pv1 ph2 br-pill transition ${!checked ? 'white' : ''}`}
        >
          {labelOff}
        </div>
        <div
          ref={elementOnRef}
          className={`relative f6 pv1 ph2 br-pill transition ${checked ? 'white' : ''}`}
        >
          {labelOn}
        </div>
        {elementOffRef && elementOnRef && (
          <div
            className={`
              absolute z--1 top-0 bottom-0 flex flex-center
              ph2 pv1 h-100 f5 white bg-blue500 br-pill transition
              ${disabled ? 'pointer-event-none' : 'pointer'}
            `}
            onClick={disabled ? null : onChange}
            ref={elementBackRef}
          />
        )}
      </div>
    </div>
  )
}
